import React from 'react';
import KioskQuestionnaires from '../../containers/Questionnaires/KioskQuestionnaires';
import { withKioskAuth } from '../../containers/KioskAuthenticated';

export class KioskQuestionnairePageInternal extends React.Component {
  render() {
    return (
      <KioskQuestionnaires />
    );
  }
}

export const KioskQuestionnairePage = withKioskAuth(KioskQuestionnairePageInternal);